export default __webpack_public_path__ + "static/logo-with-federations-b7a0c924eaf54f80f988c9d798f8c6ea.svg";